export default "__VITE_ASSET__qO9gh3uM__"